import type { Content, JSONSchema } from '@plone/types';
import type { IntlShape } from 'react-intl';

type SchemaEnhancerArgs = {
  schema: JSONSchema & { addMessage: string };
  formData: any;
  intl: IntlShape;
  navRoot: Content;
  contentType: string;
};

export const ButtonSchemaEnhancer = ({
  schema,
  formData: data,
}: SchemaEnhancerArgs): JSONSchema => {
  return {
    ...schema,
    required: ['href', 'label', ...(data?.isCircle ? ['icon'] : [])],
  };
};
